import { Required } from "@resolve/hostcfg.metadata";
import { BaseDeviceProps } from "./deviceProps";

export class SkytapProps extends BaseDeviceProps {
  @Required
  username: string = undefined;
  @Required
  apiKey: string = undefined;
}